import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { MapContainer, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css'
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import Geocordinate from './Geocordinate';


interface Props {
    isDialogOpened: boolean,
    handleCloseDialog: any,
    action: string,
}
export default function Mapbox(props: Props) {
    const mapPosition: any = [-33.8130646, 151.0067153]
    const handleClose = () => {
        props.handleCloseDialog(false)
    };

    return (
        <Dialog open={props.isDialogOpened} onClose={handleClose} fullScreen>
            <DialogTitle>{props.action}</DialogTitle>
            <DialogContent>
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>

                        <Button autoFocus color="inherit" onClick={handleClose}>
                            save
                        </Button>
                    </Toolbar>
                </AppBar>
                <MapContainer center={mapPosition} zoom={10}>
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Geocordinate/>
                </MapContainer>
            </DialogContent>
        </Dialog>
    )
}